'use client';

import { captureCause } from '../../../shared/utils/sentry';
import { Exit } from 'effect';
import { useEffect } from 'react';

import sendPageViewEvents from '../../../effect/flow/gtm/sendPageViewEvents';
import { RuntimeClient } from '@vs-shop/engine/runtime/RuntimeClient';
import type { GtmPageType } from '@vs-shop/schemas/gtm/page-view';

type Props = {
  pageType: GtmPageType;
  breadcrumbs?: string[];
};

export function SendPageViewGtmEvent({ pageType, breadcrumbs }: Props) {
  useEffect(() => {
    const breadcrumbsStr = breadcrumbs?.join('|');

    void RuntimeClient.runPromiseExit(
      sendPageViewEvents({
        pageType,
        breadcrumbs: breadcrumbsStr,
      })
    ).then((exit) => {
      Exit.match(exit, {
        onSuccess: () => {
          // Page view event sent successfully
        },
        onFailure: (cause) => {
          captureCause(cause, {
            component: 'SendPageViewGtmEvent',
            action: 'Send page view event failed',
            additionalData: {
              pageType,
              breadcrumbs,
            },
          });
        },
      });
    });
  }, [pageType, breadcrumbs]);

  return null;
}
